import * as Sentry from '@sentry/react'

// `{{SENTRY_DSN}}` is the build-time placeholder swapped at container
// start by start.sh. Treat unsubstituted placeholders as "no DSN" so
// dev builds and operators-without-the-flag get a no-op SDK.
const RAW_DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined
const DSN = RAW_DSN && !RAW_DSN.startsWith('{{') ? RAW_DSN : undefined

export function initSentry(): void {
  if (!DSN) return

  Sentry.init({
    dsn: DSN,
    environment: import.meta.env.MODE,
    release: (import.meta.env.VITE_GIT_SHA as string | undefined) || undefined,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    sendDefaultPii: false,
    beforeBreadcrumb(breadcrumb) {
      if ((breadcrumb.category === 'fetch' || breadcrumb.category === 'xhr') && breadcrumb.data?.url) {
        const url = breadcrumb.data.url as string
        const qIndex = url.indexOf('?')
        if (qIndex >= 0) {
          breadcrumb.data.url = url.slice(0, qIndex)
        }
      }
      return breadcrumb
    },
    beforeSend(event) {
      // The submit app receives free-text feedback. Drop any captured
      // request data defensively even though browser SDKs typically
      // don't capture POST bodies.
      if (event.request) {
        delete event.request.data
      }
      return event
    },
  })
}
